import React from 'react';
import logo from '../Assest/Logo.webp'; 

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        {/* Left - Logo */}
        <div style={styles.left}>
          <img src={logo} alt="Billionaire Aniket" style={styles.logo} />
        </div>

        {/* Center - Links and Copyright */}
        <div style={styles.center}>
          <div style={styles.links}>
            <a href="/privacy-policy" style={styles.link}>Privacy Policy</a>
            <a href="/terms-conditions" style={styles.link}>Terms & Conditions</a>
            <a href="/refund-policy" style={styles.link}>Refund Policy</a>
          </div>
          <p style={styles.copy}>
            © 2024–25. All Rights Reserved | Billionaire Aniket Healing & Coaching LLP
          </p>
        </div>

        {/* Right - Contact Button */}
        <div style={styles.right}>
          <a href="/contact" style={styles.contactBtn}>Contact Us</a>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: 'linear-gradient(180deg, #000b3e 0, #020202 59%)',
    color: '#fff',
    padding: '10px 20px 40px',
    fontFamily: 'Outfit, sans-serif',
    marginBottom:'90px',
    height: '55vh',
    
  },
  container: {
    maxWidth: '1300px',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
    textAlign: 'center',
   
  },
  left: {
    flex: '1',
    minWidth: '200px',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  logo: {
    width: '180px',
    borderRadius: '20px',
  },
  center: {
    flex: '2',
    minWidth: '280px',
    marginTop:'15%'
  },
  links: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    marginBottom: '10px',
  },
  link: {
    color: '#fff',
    textDecoration: 'underline',
    fontSize: '14px',
  },
  copy: {
    fontSize: '14px',
    marginTop: '8px',
  },
  right: {
    flex: '1',
    minWidth: '200px',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  contactBtn: {
    backgroundColor: '#f6a500',
    padding: '12px 24px',
    borderRadius: '30px',
    color: '#fff',
    fontWeight: 'bold',
    textDecoration: 'none',
    fontSize: '16px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
    transition: 'all 0.3s ease',
  }
};

export default Footer;
